/**
 * Opt-in debug logging (default: silent).
 *
 * Enable one area:
 *   localStorage.setItem("debug:patient-page", "true")
 * Enable everything that uses dbgLog:
 *   localStorage.setItem("debug:app", "true")
 */

export function isDebugEnabled(key) {
  if (typeof window === "undefined") return false;
  try {
    if (window.localStorage?.getItem("debug:app") === "true") return true;
    if (!key) return false;
    return window.localStorage?.getItem(`debug:${key}`) === "true";
  } catch {
    return false;
  }
}

/** Logs only when debug:app or debug:key is enabled. */
export function dbgLog(key, ...args) {
  if (isDebugEnabled(key)) console.log(...args);
}
